export default "__VITE_ASSET__8b788255__"